import keys from '@debbie/common/dist/cache/keys.js';
import { useMemo } from 'react';
import * as api from '../api/updates.js';
import { h } from '../index.js';
import { mapLoadable } from '../Loadable/utils.js';
import q from '../query.js';
export const updateTypesEntity = `update-types`;
const updateTypesKey = `all-update-types`;
export const useUpdateTypes = () => q.query(updateTypesKey, api.types, keys.read.collection(updateTypesEntity));
export const ensureUpdateTypesLoaded = () => q.ensureLoaded(updateTypesKey);
export const useUpdateTypesMap = () => {
    const updateTypesLoadable = useUpdateTypes();
    const map = useMemo(() => {
        if (!h.hasData(updateTypesLoadable)) {
            return null;
        }
        const result = {};
        for (const ut of updateTypesLoadable.data) {
            result[ut.updateTypeId] = ut;
        }
        return result;
    }, [updateTypesLoadable]);
    return mapLoadable(updateTypesLoadable, map);
};
//# sourceMappingURL=index.js.map